import { Injectable } from "@angular/core";
import { tooltip } from "../../../../config/tooltip.json";
@Injectable({
  providedIn: "root",
})
export class CommonService {
  constructor() {}

  capitalize = (str: string) => {
    try {
      if (str === null || str === "") return "";
      else str = str.toString();
      return str.replace(/\w\S*/g, function (txt) {
        return (txt.charAt(0) ? txt.charAt(0).toUpperCase() : '') + (txt.substr(1) ? txt.substr(1).toLowerCase() : '');
      });
    } catch (error) {}
  };

  sentenceCase(str: string) {
    return typeof str === "string"
      ? str.toLowerCase().replace(/(^\s*\w|[\.\!\?]\s*\w)/g, function (c) {
          return c.toUpperCase();
        })
      : null;
  }

  public getTooltip = (btnName: string) => {
    try {
      console.log(btnName);
      if (btnName === "cancel") {
        return btnName === "cancel" ? this.capitalize(tooltip.cancel) : null;
      } else if (btnName === "create") {
        return btnName === "create" ? this.capitalize(tooltip.create) : null;
      } else if (btnName === "update") {
        return btnName === "update" ? this.capitalize(tooltip.update) : null;
      } else if (btnName === "activate") {
        return btnName === "activate"
          ? this.capitalize(tooltip.activate)
          : null;
      } else if (btnName === "deactivate") {
        return btnName === "deactivate"
          ? this.capitalize(tooltip.deactivate)
          : null;
      } else if (btnName === "delete") {
        return btnName === "delete" ? this.capitalize(tooltip.delete) : null;
      } else if (btnName === "view") {
        return btnName === "view" ? this.capitalize(tooltip.view) : null;
      } else if (btnName === "edit") {
        return btnName === "edit" ? this.capitalize(tooltip.edit) : null;
      } else if (btnName === "reset") {
        return btnName === "reset" ? this.capitalize(tooltip.reset) : null;
      } else if (btnName === "add") {
        return btnName === "add" ? this.capitalize(tooltip.add) : null;
      } else if (btnName === "remove") {
        return btnName === "remove" ? this.capitalize(tooltip.remove) : null;
      } else {
        return "Not in Tooltip";
      }
    } catch (error) {}
  };
}
